import { safeParseNullDefault, safeParse, removeNulls } from 'shouldve-been-js';
import FilledChecklistValueObject from './FilledChecklistValueObjectModel';

class FilledChecklist {

    private _filledChecklistId: string;
    private _checklistId: string;
    private _name: string;
    private _createdDate: Date;
    private _changedDate: Date;
    private _values: FilledChecklistValueObject[];
    private _folderId: string;
    private _sortIndex: number;

    public constructor(filledChecklistId: string, checklistId: string, name: string, createdDate: Date, changedDate: Date, values: FilledChecklistValueObject[], folderId: string, sortIndex: number) {

        this._filledChecklistId = filledChecklistId;
        this._checklistId = checklistId;
        this._name = name;
        this._createdDate = createdDate;
        this._changedDate = changedDate;
        this._values = values;
        this._folderId = folderId;
        this._sortIndex = sortIndex;
    }

    public get filledChecklistId(): string {
        return this._filledChecklistId;
    }

    public set filledChecklistId(value: string) {
        this._filledChecklistId = value;
    }

    public get checklistId(): string {
        return this._checklistId;
    }

    public set checklistId(value: string) {
        this._checklistId = value;
    }

    public get name(): string {
        return this._name;
    }

    public set name(value: string) {
        this._name = value;
    }

    public get createdDate(): Date {
        return this._createdDate;
    }

    public set createdDate(value: Date) {
        this._createdDate = value;
    }

    public get changedDate(): Date {
        return this._changedDate;
    }

    public set changedDate(value: Date) {
        this._changedDate = value;
    }

    public get values(): FilledChecklistValueObject[] {
        return this._values;
    }

    public set values(value: FilledChecklistValueObject[]) {
        this._values = value;
    }

    public get folderId(): string {
        return this._folderId;
    }

    public set folderId(value: string) {
        this._folderId = value;
    }

    public get sortIndex(): number {
        return this._sortIndex;
    }

    public set sortIndex(value: number) {
        this._sortIndex = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): FilledChecklist | null {

        const filledChecklistId: string | null = safeParseNullDefault<string>(object?._filledChecklistId, '');
        const checklistId: string | null = safeParseNullDefault<string>(object?._checklistId, '');
        const name: string = safeParse<string>(object?._name, '');
        const createdDate: Date | null = safeParseNullDefault<Date>(object?._createdDate, new Date());
        const changedDate: Date | null = safeParseNullDefault<Date>(object?._changedDate, new Date());
        const folderId: string | null = safeParseNullDefault<string>(object?._folderId, '');
        const sortIndex: number | null = safeParseNullDefault<number>(object?._sortIndex, 0);

        if (filledChecklistId === null || checklistId === null || createdDate === null || changedDate === null || folderId === null || sortIndex === null || filledChecklistId === '' || checklistId === '' || folderId === '') {
            return null;
        }

        if (!Array.isArray(object?._values)) {
            return null;
        }

        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
        const values: (FilledChecklistValueObject | null)[] = object._values.map((valueObject: any) => {
            return FilledChecklistValueObject.fromIndexedDB(valueObject);
        });   

        return new FilledChecklist(filledChecklistId, checklistId, name, createdDate, changedDate, removeNulls(values), folderId, sortIndex);
    }
}

export default FilledChecklist;